const convertUTCDateToLocalDate = (date) => {
  console.log("CONVERTING")
  console.log(date.getTime())
  console.log(date.getTimezoneOffset())
  const newDate = new Date(
    date.getTime() - ( date.getTimezoneOffset() * 60 * 1000 )
  );
  return newDate;
};

export default convertUTCDateToLocalDate;
